module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('section', {
    staticClass: "container testimonials has-text-centered"
  }, [_c('carousel', {
    attrs: {
      "autoplay": true,
      "autoplayTimeout": 10000,
      "autoplayHoverPause": true,
      "loop": true,
      "navigationEnabled": true,
      "paginationColor": 'white',
      "paginationActiveColor": 'white',
      "perPage": 1,
      "perPageCustom": [
        [768, 1]
      ]
    }
  }, _vm._l((_vm.testimonials), function(testimonial) {
    return _c('slide', {
      key: testimonial.name
    }, [_c('p', {
      staticClass: "testimonial"
    }, [_vm._v(_vm._s(testimonial.message))]), _vm._v(" "), _c('p', {
      staticClass: "testimonial-name"
    }, [_vm._v(_vm._s(testimonial.name))]), _vm._v(" "), _c('div', {
      staticClass: "home-pic"
    }, [_c('figure', {
      staticClass: "image testimonial-image"
    }, [_c('img', {
      attrs: {
        "src": testimonial.image,
        "alt": "Phil Makepeace"
      }
    })])])])
  }))], 1), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "container has-text-centered"
  }, [_c('p', [_vm._v("Phil Makepeace provides chess coaching for all ages including school clubs in London. I have consistently delivered fun and educational chess tuition to individuals, groups and schools since 2013.")]), _vm._v(" "), _c('p', [_vm._v("Whether you are already a serious player or just getting started, lessons will be carefully designed around your individual chess needs.")]), _vm._v(" "), _c('button', {
    staticClass: "button is-primary",
    attrs: {
      "onclick": "location.href='http://makepeacewithchess.com/contact'"
    }
  }, [_vm._v("Get in touch!")]), _vm._v(" "), _c('button', {
    staticClass: "button is-primary",
    attrs: {
      "onclick": "location.href='http://makepeacewithchess.com/services'"
    }
  }, [_vm._v("Services")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-390b2066","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 38
// module chunks = 0